export default "__VITE_ASSET__bae17eed__"